import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';

import { environment } from 'src/environments/environment';
import {
  AppBaseURLModule,
  AppRouterLinkModule,
  AppSigninDialogModule,
  AppSignupDialogModule,
  AppStoreIconModule
} from 'src/app/shared/modules';

import { FrontRoutingModule } from './front-routing.module';
import { FooterComponent, HeaderComponent, FrontComponent } from './components';

@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
    FrontRoutingModule,
    AppRouterLinkModule,
    AppBaseURLModule,
    AppSignupDialogModule,
    AppSigninDialogModule,
    AppStoreIconModule.forRoot({
      appleStoreURL: environment.appleStoreURL,
      googlePlayURL: environment.googlePlayURL
    })
  ],
  declarations: [FooterComponent, HeaderComponent, FrontComponent]
})
export class FrontModule {}
